import { isMobile } from '@zoomit/web-kit';

import type { MenuParserData } from '../../../types/menus';
import DefaultMenuMobile from '../default-menu/DefaultMenuMobile';
import { SearchOrientedMenuDesktop } from './SearchOrientedMenuDesktop';

const SearchOrientedMenu = (props: MenuParserData) => {
  if (isMobile) {
    return <DefaultMenuMobile {...props} />;
  } else {
    return (
      <>
        <SearchOrientedMenuDesktop {...props} />
        <DefaultMenuMobile {...props} />
      </>
    );
  }
};

export default SearchOrientedMenu;
